// src/App.js
import React, { useContext, useEffect, useState } from "react";
import { HashRouter as Router, Routes, Route, Navigate, useLocation, useNavigate } from "react-router-dom";
import Account from "./Components/App/Accounts/Account";
import Transactions from "./Components/App/Transactions/Transactions";
import Customers from "./Components/App/Customers/Customers";
import Login from "./Components/Login/Login";
import NavBar from "./Components/App/NavBar/NavBar";
import History from "./Components/App/Transactions/History/History";
import Users from "./Components/App/Users/Users";
import Premissions from "./Components/App/Users/Premissions";
import Automation from "./Components/App/Automation/Automation";
import MobileNavBar from "./Components/App/NavBar/MobileNavBar";
import { WebSocketProvider } from "./WebSocketContext";
import { Website } from "./Components/Website/Website";

const App = () => {
    const { pathname } = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (!localStorage.getItem("token") && pathname !== "/login") {
            navigate("/login");
        }
    }, [pathname]);

    return (
        <WebSocketProvider>
            <NavBar />
            <MobileNavBar />
            <div className="mt-[75px]">
                <Routes>
                    <Route path="/website" element={<Website />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/wallet" element={<Account />} />
                    <Route path="/transactions" element={<Transactions />} />
                    <Route path="/customers" element={<Customers />} />
                    <Route path="/history" element={<History />} />
                    {/* <Route path="/automation" element={<Automation />} /> */}
                    <Route path="/users" element={<Users />} />
                    <Route path="*" element={<Navigate to="/login" replace />} />
                </Routes>
            </div>
        </WebSocketProvider>
    );
};

export default App;
